// Generated by purs version 0.14.3
"use strict";
var Control_Category = require("../Control.Category/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Show = require("../Data.Show/index.js");
var Test_QuickCheck_Arbitrary = require("../Test.QuickCheck.Arbitrary/index.js");
var Test_QuickCheck_Gen = require("../Test.QuickCheck.Gen/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var Quotient = function (x) {
    return x;
};
var Canonical = function (canonical) {
    this.canonical = canonical;
};
var mkQuotient = Quotient;
var canonicalMod8 = new Canonical(function (v) {
    var $37 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($38) {
        return $37((function (v1) {
            return Data_Int.rem(v1)(8);
        })($38));
    };
});
var canonicalMod64 = new Canonical(function (v) {
    var $39 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($40) {
        return $39((function (v1) {
            return Data_Int.rem(v1)(64);
        })($40));
    };
});
var canonicalMod512 = new Canonical(function (v) {
    var $41 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($42) {
        return $41((function (v1) {
            return Data_Int.rem(v1)(512);
        })($42));
    };
});
var canonicalMod4 = new Canonical(function (v) {
    var $43 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($44) {
        return $43((function (v1) {
            return Data_Int.rem(v1)(4);
        })($44));
    };
});
var canonicalMod32 = new Canonical(function (v) {
    var $45 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($46) {
        return $45((function (v1) {
            return Data_Int.rem(v1)(32);
        })($46));
    };
});
var canonicalMod256 = new Canonical(function (v) {
    var $47 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($48) {
        return $47((function (v1) {
            return Data_Int.rem(v1)(256);
        })($48));
    };
});
var canonicalMod2 = new Canonical(function (v) {
    var $49 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($50) {
        return $49((function (v1) {
            return Data_Int.rem(v1)(2);
        })($50));
    };
});
var canonicalMod16 = new Canonical(function (v) {
    var $51 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($52) {
        return $51((function (v1) {
            return Data_Int.rem(v1)(16);
        })($52));
    };
});
var canonicalMod128 = new Canonical(function (v) {
    var $53 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($54) {
        return $53((function (v1) {
            return Data_Int.rem(v1)(128);
        })($54));
    };
});
var canonicalMod1024 = new Canonical(function (v) {
    var $55 = Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
    return function ($56) {
        return $55((function (v1) {
            return Data_Int.rem(v1)(1024);
        })($56));
    };
});
var canonicalId = new Canonical(function (v) {
    return Control_Category.identity(Control_Category.categoryFn);
});
var canonicalAbs = function (dictOrd) {
    return function (dictRing) {
        return new Canonical(function (v) {
            return Data_Ord.abs(dictOrd)(dictRing);
        });
    };
};
var canonical = function (dict) {
    return dict.canonical;
};
var runQuotient = function (dictCanonical) {
    return function (v) {
        return canonical(dictCanonical)(Type_Proxy["Proxy"].value)(v);
    };
};
var coarbitraryQuotient = function (dictCoarbitrary) {
    return function (dictCanonical) {
        return new Test_QuickCheck_Arbitrary.Coarbitrary((function () {
            var $57 = Test_QuickCheck_Arbitrary.coarbitrary(dictCoarbitrary);
            var $58 = runQuotient(dictCanonical);
            return function ($59) {
                return $57($58($59));
            };
        })());
    };
};
var eqQuotient = function (dictEq) {
    return function (dictCanonical) {
        return new Data_Eq.Eq(function (a) {
            return function (b) {
                return Data_Eq.eq(dictEq)(runQuotient(dictCanonical)(a))(runQuotient(dictCanonical)(b));
            };
        });
    };
};
var ordQuotient = function (dictOrd) {
    return function (dictCanonical) {
        return new Data_Ord.Ord(function () {
            return eqQuotient(dictOrd.Eq0())(dictCanonical);
        }, function (a) {
            return function (b) {
                return Data_Ord.compare(dictOrd)(runQuotient(dictCanonical)(a))(runQuotient(dictCanonical)(b));
            };
        });
    };
};
var showQuotient = function (dictShow) {
    return function (dictCanonical) {
        return new Data_Show.Show(function (a) {
            return "(mkQuotient " + (Data_Show.show(dictShow)(runQuotient(dictCanonical)(a)) + ")");
        });
    };
};
var arbitraryQuotient = function (dictArbitrary) {
    return function (dictCanonical) {
        return new Test_QuickCheck_Arbitrary.Arbitrary(Data_Functor.map(Test_QuickCheck_Gen.functorGen)(mkQuotient)(Test_QuickCheck_Arbitrary.arbitrary(dictArbitrary)));
    };
};
module.exports = {
    Canonical: Canonical,
    canonical: canonical,
    mkQuotient: mkQuotient,
    runQuotient: runQuotient,
    eqQuotient: eqQuotient,
    ordQuotient: ordQuotient,
    showQuotient: showQuotient,
    arbitraryQuotient: arbitraryQuotient,
    coarbitraryQuotient: coarbitraryQuotient,
    canonicalId: canonicalId,
    canonicalAbs: canonicalAbs,
    canonicalMod2: canonicalMod2,
    canonicalMod4: canonicalMod4,
    canonicalMod8: canonicalMod8,
    canonicalMod16: canonicalMod16,
    canonicalMod32: canonicalMod32,
    canonicalMod64: canonicalMod64,
    canonicalMod128: canonicalMod128,
    canonicalMod256: canonicalMod256,
    canonicalMod512: canonicalMod512,
    canonicalMod1024: canonicalMod1024
};
